import { render, staticRenderFns } from "./PersonalDocument.vue?vue&type=template&id=3885a83c"
import script from "./PersonalDocument.vue?vue&type=script&lang=js"
export * from "./PersonalDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports